export const OAUTH_CLIENT_ID =
    "878230613093-doc10fac8fhecj8kj9pvkd7odjuto48a.apps.googleusercontent.com";

export const DROPBOX_ACCESS_TOKEN =
    "nAnnFGYO6B4AAAAAAAAPn2r_vbG6K_9C0bw7ug63B4INprZ9Cxj4qXUvD8qR0IgW";
